import styled from 'styled-components'
import { theme } from '../../../../../style/theme'
import { colorTheme } from '../../../../../style/theme/colorTheme'

export const QrCodeTextWrap = styled.div`
	font-size: inherit;
	font-family: ${theme.fontRobotoMedium};
	display: flex;
	flex-direction: column;
	gap: 0.23em;
`
QrCodeTextWrap.displayName = 'QrCodeTextWrap'

export const QrCodeIconsWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	gap: 0.23em 0.45em;

	> .APPLE_PAY, .GOOGLE_PAY {
		width: 1.7em;
		height: 0.73em;
	}

	> .AMERICAN_EXPRESS {
		width: 2em;
		height: 0.73em;
	}

	> .KLARNA {
		width: 2.2em;
		height: 0.5em;
	}

	> .SOFORT {
		width: 2.2em;
		height: 0.73em;
	}

	> .GIROPAY {
		width: 2.7em;
		height: 0.73em;
	}

	> .PAYPAL {
		width: 2.4em;
		height: 0.64em;
	}
`
QrCodeIconsWrap.displayName = 'QrCodeIconsWrap'

export const TerminalTextWrap = styled.div`
	font-size: inherit;
	font-family: ${theme.fontRobotoMedium};
	display: flex;
	gap: 0.23em;
	justify-content: space-between;
	align-items: center;
	width: 100%;
`
TerminalTextWrap.displayName = 'TerminalTextWrap'

export const TerminalInfoTextWrap = styled.div`
	display: flex;
	gap: 0.23em;
	align-items: center;

	> svg.info {
		width: 1em;
		height: 1em;
		fill: ${colorTheme.cartModal.modalPayment.paymentMethod.terminal.icon};
		flex-shrink: 0;
	}
`
TerminalInfoTextWrap.displayName = 'TerminalInfoTextWrap'

export const TerminalInfoText = styled.div`
	font-weight: 400;
	font-size: 0.81em;
	color: ${colorTheme.cartModal.modalPayment.paymentMethod.terminal.text};
	text-wrap: nowrap;
`
TerminalInfoText.displayName = 'TerminalInfoText'

